import { render, staticRenderFns } from "./SubMenuLink.vue?vue&type=template&id=2aff57d1&"
import script from "./SubMenuLink.vue?vue&type=script&lang=js&"
export * from "./SubMenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports